// Header.js
import React from 'react';
import { NavLink } from "react-router-dom";

import Title from './Title';
import HeaderMenu from './HeaderMenu';
import HeaderArea from './HeaderArea';

import Config from '../config/Config';
import WidgetAjax from './../widget/WidgetAjax';

import WidgetMessage from './../widget/WidgetMessage';
import WidgetModal from './../widget/WidgetModal';

import { Form } from 'antd';
import { Input} from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css'

class Header extends React.Component 
{
	constructor( props )
	{
		super(props);

		this.refTest = React.createRef();
		this.state = {
			realname:undefined,
			location : undefined,
			modification:false,
			editRroupModelOptions : {
                title : "用户详情",
                confirm : "确定",
            },
			editRpasswordOptions : {
                title : "修改密码",
                confirm : "确定",
            },
			layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
			Group : {},
			messageOptions : {
                title : "信息",
            },
			realData:undefined,
			cell:undefined,
			UID:undefined,
			username:undefined,
			email:undefined,
			timeout:null,

		}
		this.freshPage = this.freshPage.bind(this);

		this.headerMenuOnSelect = this.headerMenuOnSelect.bind(this);

		this.logout = this.logout.bind(this);
		this.onLogout = this.onLogout.bind(this);
		this.userInfo = this.userInfo.bind(this);
		this.modification = this.modification.bind(this);
		this.inputOnchange = this.inputOnchange.bind(this);
		this.onUser = this.onUser.bind(this);
		this.roupModel = this.roupModel.bind(this);
		this.password = this.password.bind(this);
		this.onRoupModel = this.onRoupModel.bind(this);
		this.onPassword = this.onPassword.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() 
	{

		this.userInfo();
		document.addEventListener('mousedown', (e)=>this.handleClickOutside(e), false);
	}
    componentWillUnmount() {
        document.removeEventListener('mousedown', (e)=>this.handleClickOutside(e), false);
    }
    handleClickOutside(e) {
        const target = e.target;
        if(this.refTest.current){
        // 组件已挂载且事件触发对象不在div内
            let result=(this.refTest.current).contains(target);
            if( !result ) {
                this.setState({
                    modification:false
                });
            }  
        }
    }
	
	 editGroupModelRef = (ref) => {

        this.editGroupModelRef =  ref ;
    }

	editRpassworRef = (ref) =>{
		this.editRpassworRef =  ref ;
	}

	messageRef = (ref) => {
		this.messageRef =  ref ;
	}

	/**
     * 部门信息input值变化触发函数
     * @param {*} value 
     * @param {*} type 
     */
	 inputOnchange( value, type, item )
	 {
		 switch( type )
		 {
			 case "name":
			 {
				 this.state["GroupName"] = value;
				 break;
			 }
			 case "remark":
			 {
				 this.state["GroupRemark"] = value;
				 break;
			 }
			 case "new_password" :
			{
				this.state["new_password"] = value;
				break;
			}
			case "email" :
			{
				this.state["email"] = value;
				break;
			}
			case "old_password" :
			{
				this.state["old_password"] = value;
				break;
			}
			case "cell" :
			{
				this.state["cell"] = value;
				break;
			}
			 case 'quota':
				 item.AMOUNT = Number(value);
				 this.setState({
					 ...this.state.quotaData,
					 ...item
				 })
				 break;
			 default:
				 break;
		 }
	 }

	userInfo()
	{

		let location = undefined;

		let data = window.sessionStorage.getItem("_user_info_");

		let res = JSON.parse(data);

		let userLoginInfo =  window.sessionStorage.getItem("_user_login_info_");

		userLoginInfo = JSON.parse(userLoginInfo);

		if( userLoginInfo.user_properties!==undefined && userLoginInfo.user_properties.default_district!==undefined )
		{
			location = userLoginInfo.user_properties.default_district.name;
		}

		this.setState({realname:res.realname, location:location,username:res.username,cell:res.cell,UID:res.UID,email:res.email})
	}

	headerMenuOnSelect( key )
	{
		if( this.props.headerOnSelect!==undefined )
		{
			this.props.headerOnSelect(key);
		}
	}

	freshPage()
	{
		if( this.props.freshPage!==undefined )
		{
			this.props.freshPage();
		}
	}

	logout()
	{
		WidgetAjax.ajax({url : Config.getBasePath()+'/logout', params : undefined, callback : this.onLogout});
	}

	onLogout(result, params )
	{
		if( result.status===0 )
		{
			sessionStorage.removeItem("_user_access_");
            sessionStorage.removeItem("_user_info_");
            sessionStorage.removeItem("_user_login_info_");
            
			if( this.props.redrict!==undefined )
			{
				this.props.redrict("/login", undefined, true);
			}
		}
	}

	modification()
	{
		let { modification } = this.state

		if(modification)
		{
			this.setState({modification:false,new_password:"",old_password:"",})
		}
		else
		{
			this.setState({modification:true,new_password:"",old_password:"",})
		}
	}

	onUser(type)
	{
		this.setState({modification:false})
		switch( type )
		{
			case "details" :
			{
				// this.props.history.push({pathname:"/home/userCreate", state:{isCreate:false, user:realData}});
				this.editGroupModelRef.open();
				break;
			}
			case "password" :
			{
				this.state["isCreate"] = false;
				this.editRpassworRef.open()
				break;
			}
		}
	}

	roupModel()
	{
		let {messageOptions,realname,cell,UID,email} = this.state

		messageOptions["isMessage"] = false;

		let params = {
			UID:UID,
            realname:realname,
            cell:cell,
			email:email
		}
		
		 WidgetAjax.ajax({url:Config.getBasePath() + '/user/update', params:params, callback:this.onRoupModel});
	}
	onRoupModel(result)
	{
		let {messageOptions,timeout} = this.state

		if(result.status === 0){
			messageOptions["message"] = "用户修改成功！";

			clearTimeout(timeout)
			timeout = setTimeout(()=>{
				this.logout()
			}, 1500)

			this.setState({timeout})
		}
		else
		{
			clearTimeout(timeout)

			messageOptions["message"] = "用户修改失败！";
		}
		
		messageOptions["isMessage"] = true;

		this.messageRef.open()
	}

	password()
	{
		let {new_password,old_password,messageOptions} = this.state

		messageOptions["isMessage"] = false;

		let oldDate =  this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
		let newDate =  this.$md5("ES_6ps" + new_password + "_N3tM").toUpperCase();

		let params = {
			old_password:oldDate,
			new_password:newDate
		}
		
 		WidgetAjax.ajax({url:Config.getBasePath() + '/update_password', params:params, callback:this.onPassword});
	}
	onPassword(result)
	{
		let {messageOptions,timeout} = this.state

		if(result.status === 0){
			messageOptions["message"] = "密码修改成功！";
			clearTimeout(timeout)
			timeout = setTimeout(()=>{
				this.logout()
			}, 1500)
		}else{
			messageOptions["message"] = "密码修改失败！";
		}
		
		messageOptions["isMessage"] = true;

		this.messageRef.open()
	}
	render() 
	{
		const { activeKey, titleNode} = this.props;

		const { realname, location, modification,editRroupModelOptions,layout,Group,editRpasswordOptions,messageOptions,new_password,username,cell,old_password,email } = this.state;

		editRroupModelOptions["confirmFunction"] = this.roupModel;
        editRpasswordOptions['confirmFunction']=this.password;

		let showHeaderArea = Config.isShowHeaderArea();

		if( this.props.titleNode!==undefined && this.props.titleNode.length!==0 )
		{
			return (
				<div className='frame-top'>
					{/* <Title title={this.props.systemTitle} />
					<HeaderMenu onSelect={this.headerMenuOnSelect} titleNode={this.props.titleNode} activeKey={activeKey}/> */}
					<div className="title-right">
						{
							titleNode.map((item, index) => {
								if( item.name==="SCRM" )
								{
									return (
										<div key={index} className="logout" style={activeKey==="system" ?  {paddingRight: '0px', float:'left'} : {display:'none'}} onClick={ ()=>{this.headerMenuOnSelect("SCRM")} }>
											<img className="headimg" src={require("../img/frame/home.svg")} alt="es-lint want to get" />
										</div>
									);
									
								}
								else if( item.name==="system" )
								{
									return (
										<div key={index}  className="logout" style={activeKey!=="system" ?  {paddingRight: '0px', float:'left'} : {display:'none'}} onClick={ ()=>{this.headerMenuOnSelect("system")} }>
											<img className="headimg" src={require("../img/frame/system.svg")} alt="es-lint want to get" />
										</div>
									);
								}
							})
						}
						<div className="logout">
							<Location location={location}/>

							<img className="headimg" src={require('../img/frame/riskuser.svg')} alt="es-lint want to get"></img>
							<span style={{padding:'10px',fontSize:'14px',color:'#000000'}} onClick={this.modification}>{ realname }</span>
							<span style={{paddingRight:'10px',color:'#000000',fontWeight:'bold'}}>｜</span>

							<div className='modification' style={modification?{display:"block"}:{display:"none"}} ref={this.refTest}>
								<button onClick={()=>this.onUser("details")}>用户详情</button>
								<button onClick={()=>this.onUser("password")}>修改密码</button>
							</div>

							<div className="logout" style={ {paddingRight: '0px'}} onClick={this.logout}>
								<img className="headimg" src={require("../img/logout.svg")} alt="es-lint want to get"  onClick={this.logout}/>
							</div>
						</div>
					</div>
					<WidgetModal options={editRroupModelOptions} onRef={this.editGroupModelRef} >
						<Form  {...layout} name="basic">
							<Form.Item label="账号" name="GoupName">
								<Input defaultValue={username} disabled  onChange={(value) => {this.inputOnchange(value, "name")}}></Input>
							</Form.Item>
							<Form.Item label="用户名称" name="remark">
								<Input defaultValue={realname} value={realname}  onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
							</Form.Item>
							
							<Form.Item label="手机号" name="cellName">
								<Input defaultValue={cell}  value={cell}  onChange={(value) => {this.inputOnchange(value, "cell")}}></Input>
							</Form.Item>

							<Form.Item label="邮箱" name="email">
								<Input defaultValue={email}  value={email}  onChange={(value) => {this.inputOnchange(value, "email")}}></Input>
							</Form.Item>
							
						</Form>
					</WidgetModal>

					<WidgetModal options={editRpasswordOptions} onRef={this.editRpassworRef} >
						<Form  {...layout} name="basic">
							<Form.Item label="账号" name="remark">
								<Input defaultValue={"admin"} disabled onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
							</Form.Item>
							<Form.Item label="当前密码" name="old_password">
								<Input  placeholder="请输入要新的密码" defaultValue={old_password}  onChange={(value) => {this.inputOnchange(value, "old_password")}}></Input>
							</Form.Item>
							<Form.Item label="新密码" name="new_password">
								<Input  placeholder="请输入要修改的密码" defaultValue={new_password}  onChange={(value) => {this.inputOnchange(value, "new_password")}}></Input>
							</Form.Item>
						</Form>
					</WidgetModal>

					<WidgetMessage options={messageOptions} onRef={this.messageRef} />
				</div>
			);
		}
		else
		{
			return(
				<div className='frame-top'>
					{/* <Title title={this.props.systemTitle} /> */}
					<div className="title-right">
						
						{
							titleNode.map((item, index) => {
								if( item.name==="SCRM" )
								{
									return (
										<div key={index} className="logout" style={activeKey!=="home" ?  {paddingRight: '0px', float:'left'} : {display:'none'}} onClick={ ()=>{this.headerMenuOnSelect("SCRM")} }>
											<img className="headimg" src={require("../img/frame/home.svg")} alt="es-lint want to get" />
										</div>
									);
									
								}
								else if( item.name==="system" )
								{
									return (
										<div key={index} className="logout" style={activeKey==="home" ?  {paddingRight: '0px', float:'left'} : {display:'none'}} onClick={ ()=>{this.headerMenuOnSelect("system")} }>
											<img className="headimg" src={require("../img/frame/system.svg")} alt="es-lint want to get" />
										</div>
									);
								}
							})
						}
						<div className="logout"> 
						
							<Location location={location}/>

							<img className="headimg" src={require('../img/frame/riskuser.svg')} alt="es-lint want to get"></img>
							<span style={{padding:'10px',fontSize:'14px',color:'#000000'}}>{ realname }</span>
							<span style={{paddingRight:'10px',color:'#000000',fontWeight:'bold'}}>｜</span>

							<div className="logout" style={ {paddingRight: '0px'}} onClick={this.logout}>
								<img className="headimg" src={require("../img/logout.svg")} alt="es-lint want to get" />
								{/* <span className="out" style={{padding: '10px',fontSize:'14px',color: 'rgb(255, 255, 255)'}}>退出</span> */}
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

export default Header

export const Location = ({ location}) => 
{
	if( location!==undefined )
	{
		return (
			<div style={{float: 'left'}}>
				<img className="headimg" src={require('../img/frame/location.svg')} alt="es-lint want to get"></img>
				<span style={{padding:'10px',fontSize:'14px',color:'#000000'}}>{ location }</span>
				<span style={{paddingRight:'10px',color:'#000000',fontWeight:'bold'}}>｜</span>
			</div>
		)
	}
	else
	{
		return "";
	}
}